"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroupContext = void 0;
var _react = require("react");
var ButtonGroupContext = /*#__PURE__*/(0, _react.createContext)({});
exports.ButtonGroupContext = ButtonGroupContext;